<script setup>
defineProps({
    type: {
        type: String,
        default: "submit",
    },
});
</script>

<template>
    <el-button type="primary" :native-type="type">
        <slot />
    </el-button>
</template>
